<ng-container *ngIf="league$ | async as league">
    <challenge-contestant
        *ngIf="league && league.entry && (contestant$ | async)"
        [contestant]="contestant$ | async"
        [league]="league.entry"
        [description]="description$ | async"
    ></challenge-contestant>
</ng-container>